import React, {useEffect, useReducer, useState} from 'react';
import { Link } from 'react-router-dom';
import './ModernHeader.css';

// Logo URL used across header (desktop + mobile)
const logoUrl = "https://senoffre.com/storage/app/logo/thumb-1500x1500-logo-dark-67dc8fcc93998.png";

function ModernNavToggle(){
    const toggleBtn = document.getElementById('modern-mobile-toggle');
    const mobileNav = document.getElementById('modern-mobile-nav');
    const searchOverlay = document.getElementById('modern-search-overlay');
    
    if (toggleBtn && mobileNav) {
        toggleBtn.classList.toggle("open");
        mobileNav.classList.toggle("open");
        document.body.classList.toggle("nav-open");
    }
}

function ModernSearchToggle(){
    const searchOverlay = document.getElementById('modern-search-overlay');
    const searchInput = document.getElementById('modern-search-input');
    
    if (searchOverlay) {
        searchOverlay.classList.toggle("open");
        if (searchOverlay.classList.contains("open") && searchInput) {
            setTimeout(() => searchInput.focus(), 100);
        }
    }
}

const modernMenuItems = [
    {
        title: 'Accueil',
        to: '/',
        path: '1',
        icon: 'fa-solid fa-home'
    },
    {
        title: 'Offres',
        path: '2',
        icon: 'fa-solid fa-briefcase',
        isDropdown: true,
        submenu: [
            { title: 'Toutes les offres', to: '/posts', path: '2-1', icon: 'fa-solid fa-list' }
        ]
    },
    {
        title: 'Tarifs',
        to: '/pricing',
        path: '3',
        icon: 'fa-solid fa-tags'
    },
    {
        title: 'Contact',
        to: '/contact',
        path: '5',
        icon: 'fa-solid fa-envelope'
    }
];


const reducer = (previousState, updatedState) => ({
    ...previousState,
    ...updatedState,
});

const initialState = {
    activeSubmenu: "",
    mobileNavOpen: false,
    searchOpen: false,
    loginDropdownOpen: false
};

function Header(props) {
    const [state, setState] = useReducer(reducer, initialState);
    const [headerFix, setHeaderFix] = useState(false);
    const [pathActive, setPathActive] = useState('1');

    const handleSubmenuToggle = (menuTitle) => {
        setState({
            activeSubmenu: state.activeSubmenu === menuTitle ? "" : menuTitle
        });
    };

    const handleLoginDropdownToggle = () => {
        setState({
            loginDropdownOpen: !state.loginDropdownOpen
        });
    };

    useEffect(() => {
        const handleScroll = () => {
            setHeaderFix(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.modern-login-dropdown')) {
                setState({ loginDropdownOpen: false });
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);
    
    return(
        <>
            <div className="modern-header-wrapper">
                <header className={`modern-header ${headerFix ? "is-fixed" : ""} ${props.style || ""}`}>
                    <div className="modern-main-bar">
                        <div className="container">
                            <div className="modern-header-container">
                                {/* Logo */}
                                <div className="modern-logo-header">
                                    <Link to="/" className="modern-logo-link">
                                        <img src={logoUrl} alt="SenOffre" className="modern-logo-img" />
                                    </Link>
                                </div>

                                {/* Desktop Navigation */}
                                <nav className="modern-nav">
                                    {modernMenuItems.map((item, index) => (
                                        <div key={index} className="modern-nav-item">
                                            {item.isDropdown ? (
                                                <div 
                                                    className={`modern-dropdown ${state.activeSubmenu === item.title ? 'open' : ''}`}
                                                    onMouseEnter={() => handleSubmenuToggle(item.title)}
                                                    onMouseLeave={() => handleSubmenuToggle("")}
                                                >
                                                    <span className="modern-nav-link modern-dropdown-toggle">
                                                        <i className={item.icon}></i>
                                                        {item.title}
                                                    </span>
                                                    <div className="modern-dropdown-menu">
                                                        {item.submenu.map((subItem, subIndex) => (
                                                            <Link
                                                                key={subIndex}
                                                                to={subItem.to}
                                                                className="modern-dropdown-item"
                                                                onClick={() => setPathActive(subItem.path)}
                                                            >
                                                                <i className={subItem.icon}></i>
                                                                {subItem.title}
                                                            </Link>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <Link
                                                    to={item.to}
                                                    className={`modern-nav-link ${pathActive === item.path ? 'active' : ''}`}
                                                    onClick={() => setPathActive(item.path)}
                                                >
                                                    <i className={item.icon}></i>
                                                    {item.title}
                                                </Link>
                                            )}
                                        </div>
                                    ))}
                                </nav>

                                {/* Extra Navigation */}
                                <div className="modern-extra-nav">
                                    <button 
                                        className="modern-search-btn"
                                        onClick={ModernSearchToggle}
                                        title="Rechercher"
                                    >
                                        <i className="fa-solid fa-magnifying-glass"></i>
                                    </button>

                                    <div className={`modern-login-dropdown ${state.loginDropdownOpen ? 'open' : ''}`}>
                                        <button 
                                            className="modern-login-btn"
                                            onClick={handleLoginDropdownToggle}
                                        >
                                            <i className="fa-solid fa-user"></i>
                                            Connexion
                                        </button>
                                        <div className="modern-login-menu">
                                            <Link 
                                                to="/admin/login" 
                                                className="modern-login-item"
                                                onClick={() => setState({ loginDropdownOpen: false })}
                                            >
                                                <i className="fa-solid fa-sign-in-alt"></i>
                                                Se connecter
                                            </Link>
                                            <Link 
                                                to="/register" 
                                                className="modern-login-item"
                                                onClick={() => setState({ loginDropdownOpen: false })}
                                            >
                                                <i className="fa-solid fa-user-plus"></i>
                                                S'inscrire
                                            </Link>
                                        </div>
                                    </div>

                                    <button 
                                        className="modern-mobile-toggle"
                                        id="modern-mobile-toggle"
                                        onClick={ModernNavToggle}
                                    >
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            {/* Mobile Navigation */}
            <nav className="modern-mobile-nav" id="modern-mobile-nav">
                <div className="modern-mobile-logo">
                    <Link to="/" className="modern-logo-link" onClick={ModernNavToggle}>
                        <img 
                            src={logoUrl} 
                            alt="SenOffre" 
                            className="modern-logo-img"
                        />
                    </Link>
                </div>

                <ul className="modern-mobile-nav-list">
                    {modernMenuItems.map((item, index) => (
                        <li key={index} className={`modern-mobile-nav-item ${item.isDropdown && state.activeSubmenu === item.title ? 'open' : ''}`}>
                            {item.isDropdown ? (
                                <>
                                    <span 
                                        className="modern-mobile-nav-link"
                                        onClick={() => handleSubmenuToggle(item.title)}
                                    >
                                        <i className={item.icon}></i>
                                        {item.title}
                                        <i className="fa-solid fa-chevron-down" style={{marginLeft: 'auto'}}></i>
                                    </span>
                                    <div className="modern-mobile-submenu">
                                        {item.submenu.map((subItem, subIndex) => (
                                            <Link
                                                key={subIndex}
                                                to={subItem.to}
                                                className="modern-mobile-submenu-item"
                                                onClick={() => {
                                                    setPathActive(subItem.path);
                                                    ModernNavToggle();
                                                }}
                                            >
                                                <i className={subItem.icon}></i>
                                                {subItem.title}
                                            </Link>
                                        ))}
                                    </div>
                                </>
                            ) : (
                                <Link
                                    to={item.to}
                                    className={`modern-mobile-nav-link ${pathActive === item.path ? 'active' : ''}`}
                                    onClick={() => {
                                        setPathActive(item.path);
                                        ModernNavToggle();
                                    }}
                                >
                                    <i className={item.icon}></i>
                                    {item.title}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>

                <div className="modern-mobile-footer">
                    <div className="modern-mobile-auth">
                        <Link 
                            to="/admin/login" 
                            className="modern-mobile-auth-btn primary"
                            onClick={ModernNavToggle}
                        >
                            <i className="fa-solid fa-sign-in-alt"></i>
                            Se connecter
                        </Link>
                        <Link 
                            to="/register" 
                            className="modern-mobile-auth-btn secondary"
                            onClick={ModernNavToggle}
                        >
                            <i className="fa-solid fa-user-plus"></i>
                            S'inscrire
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Search Overlay */}
            <div className="modern-search-overlay" id="modern-search-overlay">
                <div className="modern-search-container">
                    <button 
                        className="modern-search-close"
                        onClick={ModernSearchToggle}
                    >
                        <i className="fa-solid fa-times"></i>
                    </button>
                    <input 
                        type="text"
                        className="modern-search-input"
                        id="modern-search-input"
                        placeholder="Rechercher des Appels d'offres..."
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                // Handle search functionality here
                                console.log('Search:', e.target.value);
                                ModernSearchToggle();
                            }
                        }}
                    />
                </div>
            </div>
        </>
    )
}
export default Header;